import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Tab, Nav, NavItem, Row, Col } from 'react-bootstrap';
import { isMoment } from 'moment';
import { Translate } from '../../shared/LanguageService';
import StylingUserForm from './form/StylingUserForm';
import FormInputChangeHandler from '../../shared/form/FormInputChangeHandler';
import * as Actions from './actions/StylingUserActions';
import { IStylingUser, IRole, IWorkingHour } from './Entities';
import notify from '../../shared/feedback/notifications';
import { assign } from '../../shared/Assign';
import { handleError } from '../../shared/ErrorCatching';
import IWorkingAreaMap from '../workareas/IWorkingAreaMap';
import { WorkAreasForm } from './form/WorkAreasForm';
import WorkingHoursForm from './form/WorkingHoursForm';
import * as StylingUserReducer from './reducer/StylingUserReducer';
import { IStylingFirm } from '../stylingfirms/Entities';
import moment from 'moment';

interface IProps {
    showModal: boolean;
    toggleModal: boolean;
    stylingUserId: number;
    stylingUser: IStylingUser;
    workingAreaMaps: IWorkingAreaMap[];
    availableRoles: IRole[];
    availableLanguagesKeys: any;
    availableFirms: IStylingFirm[];
    actions: any;
    user: any;
}

interface IState {
    errors: {};
    stylingUser?: IStylingUser;
    creating: boolean;
    selectedProduct: number;
    shouldUpdateMap: boolean;
    currentMapIndex: number;
}

class StylingUserModal extends React.Component<IProps, IState> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: IProps, context: any) {
        super(props, context);
        this.state = {
            errors: {},
            creating: false,
            selectedProduct: -1,
            shouldUpdateMap: false,
            stylingUser: {
                id: -1,
                name: '',
                email: '',
                languageKey: 'sv',
                roleId: -1,
                role: '',
                phoneNumber: '',
                profileImageReference: '',
                stylingFirmId: -1,
                stylingFirmName: '',
                username: '',
                maps: [],
                workingHours: StylingUserReducer.getDefaultWorkingConfig()
            },
            currentMapIndex: 0
        };

        this.save = this.save.bind(this);
        this.selectedProductChanged = this.selectedProductChanged.bind(this);
        this.save = this.save.bind(this);
        this.onChange = this.onChange.bind(this);
        this.setDefaultConfig = this.setDefaultConfig.bind(this);
        this.onMapChange = this.onMapChange.bind(this);

        this.onChangeStartTime;
    }

    UNSAFE_componentWillMount() {
        this.props.actions.loadMetaData()
        .then(() => {
            if (this.props.availableFirms.length === 1) {
                var stylingUser = assign({},this.state.stylingUser);
                stylingUser.stylingFirmId = this.props.availableFirms[0].id
                this.setState({
                    stylingUser: stylingUser
                });
            }
        });

        if (this.props.stylingUserId > 0) {
            this.props.actions
                .getStylingUser(this.props.stylingUserId)
                .then(() => {
                    this.setState({
                        stylingUser: this.props.stylingUser
                    });
                })
                .catch((error: any) => {
                    handleError(error);
                    notify.failure(
                        Translate('styling-users/notification/error/unable-to-fetch-data')
                    );
                });
        }
    }

    save() {
        const { stylingUser } = this.state;

        const user = {
            ...stylingUser,
            email:
                !stylingUser.email || stylingUser.email.length < 1
                    ? stylingUser.username
                    : stylingUser.email,
            maps: stylingUser.maps.map((map: IWorkingAreaMap) => {
                let newMap: IWorkingAreaMap = assign({}, map);
                newMap.polygon = assign([], map.polygon);
                return newMap;
            })
        };

        this.setState({ creating: true, stylingUser: user }, () => {
            if (stylingUser.id > 0) {
                this.props.actions
                    .update(this.state.stylingUser)
                    .then((result) => {
                        this.setState({ creating: false });
                        this.props.toggleModal();
                        notify.success(Translate('styling-user/notification/updated'));
                    })
                    .catch((error: any) =>
                        handleError(error, (errors: any): void => {
                            this.setState({ errors: errors, creating: false });
                        })
                    );
            } else {
                this.props.actions
                    .create(this.state.stylingUser)
                    .then((result) => {
                        this.setState({ creating: false });
                        this.props.toggleModal();
                        notify.success(Translate('styling-user/notification/added'));
                    })
                    .catch((error: any) =>
                        handleError(error, (errors: any): void => {
                            this.setState({ errors: errors, creating: false });
                        })
                    );
            }
        });
    }

    onChange(e) {
        const stylingUser = assign({}, this.state.stylingUser);

        const value = e.target.value;

        if (e.target.name === 'role') {
            stylingUser.roleId = value;
        } else {
            stylingUser[e.target.name] = value;
        }

        this.setState({ stylingUser: stylingUser });
    }

    selectedProductChanged(e: React.FormEvent<HTMLInputElement>) {
        this.setState({ selectedProduct: Number(e.currentTarget.value) });
    }

    setTabValidationError(...properties: string[]) {
        if (!this.props.errors || Object.keys(this.props.errors).length === 0) {
            return null;
        }

        let hasErrors = properties.some((prop: string) => {
            return this.props.errors[prop] !== undefined;
        });

        return hasErrors ? (
            <i className="material-icons material-icons-danger material-icons-label md-18">error</i>
        ) : null;
    }

    setDefaultConfig(workingAreaMap: any) {
        let workingAreaMaps = this.state.stylingUser.maps;

        for (let i = 0; i < workingAreaMaps.length; i++) {
            workingAreaMaps[i].polygon = workingAreaMap.polygon;
            workingAreaMaps[i].usePolygon = workingAreaMap.usePolygon;
            workingAreaMaps[i].useCircle = workingAreaMap.useCircle;
            workingAreaMaps[i].circleCenter = workingAreaMap.circleCenter;
            workingAreaMaps[i].circleRadius = workingAreaMap.circleRadius;
            workingAreaMaps[i].base = workingAreaMap.base;
        }

        this.onMapChange(workingAreaMaps, 1);
    }

    onMapChange(maps: IWorkingAreaMap[], userSite: number) {
        const user = {
            ...this.state.stylingUser,
            maps: maps
        };
        this.setState({ stylingUser: user } as IState);
    }

    onChangeStartTime = (dayofweek: number, time: string) => {
        const { stylingUser } = this.state;
        let ptime = time;

        if (moment.isMoment(time)) {
            ptime = moment(time).locale('en').format('HH:mm');
        }

        const newStylingUser: IStylingUser = {
            ...stylingUser,
            workingHours: stylingUser.workingHours.map((hour: IWorkingHour) => {
                if (hour.day === dayofweek) {
                    return {
                        ...hour,
                        start: ptime
                    };
                }
                return hour;
            })
        };

        this.setState({
            stylingUser: newStylingUser
        });
    };

    onChangeEndTime = (dayofweek: number, time: string) => {
        const { stylingUser } = this.state;
        let ptime = time;

        if (moment.isMoment(time)) {
            ptime = moment(time).locale('en').format('HH:mm');
        }

        const newStylingUser: IStylingUser = {
            ...stylingUser,
            workingHours: stylingUser.workingHours.map((hour: IWorkingHour) => {
                if (hour.day === dayofweek) {
                    return {
                        ...hour,
                        end: ptime
                    };
                }
                return hour;
            })
        };

        this.setState({
            stylingUser: newStylingUser
        });
    };

    onChangeIsAvailable = (dayofweek: number, isAvailable: boolean) => {
        const { stylingUser } = this.state;
        const newStylingUser: IStylingUser = {
            ...stylingUser,
            workingHours: stylingUser.workingHours.map((hour: IWorkingHour) => {
                if (hour.day === dayofweek) {
                    return {
                        ...hour,
                        isAvailable
                    };
                }
                return hour;
            })
        };

        this.setState({
            stylingUser: newStylingUser
        });
    };

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.toggleModal}>
                <Modal.Header closeButton>
                    {this.props.stylingUserId === 0
                        ? Translate('styling-users/modal/header/add-user')
                        : Translate('styling-users/modal/header/edit-user')}
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                            <div>
                                <Nav>
                                    <NavItem eventKey={1}>
                                        {Translate('styling-user/modal/tab/styling-user')}
                                        {this.setTabValidationError(
                                            'name',
                                            'username',
                                            'email',
                                            'phoneNumber',
                                            'languageKey',
                                            'stylingFirmId',
                                            'role'
                                        )}
                                    </NavItem>
                                    <NavItem eventKey={2}>
                                        {Translate('styling-user/modal/tab/workingareas')}
                                        {this.setTabValidationError('workingareas')}
                                    </NavItem>
                                    <NavItem eventKey={3}>
                                        {Translate('styling-user/modal/tab/workinghours')}
                                        {this.setTabValidationError('workinghours')}
                                    </NavItem>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey={1}>
                                        <fieldset>
                                            <legend>
                                                {Translate(
                                                    'styling-firms/modal/form/legend/styling-firm'
                                                )}
                                            </legend>
                                            <Row>
                                                <Col md={8}>
                                                    <StylingUserForm
                                                        errors={this.state.errors}
                                                        input={this.state.stylingUser}
                                                        onChange={this.onChange}
                                                        availableLanguages={
                                                            this.props.availableLanguagesKeys
                                                        }
                                                        availableRoles={this.props.availableRoles}
                                                        stylingfirms={this.props.availableFirms}
                                                        user={this.props.user}
                                                    />
                                                </Col>
                                            </Row>
                                        </fieldset>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey={2}>
                                        <fieldset>
                                            <Row>
                                                <Col md={8}>
                                                    <WorkAreasForm
                                                        onMapChange={(x: any) =>
                                                            this.onMapChange(x, 1)
                                                        }
                                                        photographerId={this.props.stylingUser.id}
                                                        workingAreaMaps={
                                                            this.state.stylingUser.maps
                                                        }
                                                        setDefaultConfigSe360={(x) =>
                                                            this.setDefaultConfig(x)
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </fieldset>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey={3}>
                                        <fieldset>
                                            <Row>
                                                <Col md={8}>
                                                    <WorkingHoursForm
                                                        workingHours={
                                                            this.state.stylingUser.workingHours
                                                        }
                                                        onChangeStartTime={this.onChangeStartTime}
                                                        onChangeEndTime={this.onChangeEndTime}
                                                        onChangeIsAvailable={
                                                            this.onChangeIsAvailable
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </fieldset>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.toggleModal}>
                        {Translate('styling-firms/modal/footer-button/close')}
                    </Button>
                    <Button bsStyle="primary" disabled={this.state.creating} onClick={this.save}>
                        {this.state.creating
                            ? Translate('styling-firms/modal/footer-button/saving')
                            : Translate('styling-firms/modal/footer-button/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getStylingUser: (id: number) => dispatch(Actions.getStylingUser(id)),
            loadMetaData: () => dispatch(Actions.loadMetadata()),
            create: (stylingUser: IStylingUser) => dispatch(Actions.createStylingUser(stylingUser)),
            update: (stylingUser: IStylingUser) => dispatch(Actions.updateStylingUser(stylingUser))
        }
    };
}

function mapStateToProps(state: any) {
    return {
        stylingUser: state.stylinguser.modal.stylingUser,
        availableLanguagesKeys: state.stylinguser.modal.availableLanguage,
        availableRoles: state.stylinguser.modal.availableRoles,
        availableFirms: state.stylinguser.modal.availableFirms,
        user: state.user
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StylingUserModal);
